export const infoModal = {
  id: "info-modal",
  title: "",
  content: {
    detalleBase: {},
    detalleNegocio: [],
    productos: [],
  },
};
